<template>
  <div
    class="loader"
    :style="{ transform: 'scale(' + size / 30 + ') translate(-50%, -50%)' }"
  >
    <div class="circles">
      <span
        v-for="index in circlesNumber"
        :key="index"
        :class="'circle-' + index"
      />
      <!--            <span class="two"></span>-->
      <!--            <span class="three"></span>-->
    </div>
    <div class="pacman">
      <span class="top" />
      <span class="bottom" />
      <span class="left" />
      <div class="eye" />
    </div>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'PacmanLoader',
  props: {
    size: { default: 30 },
    circlesNumber: { default: 3 }
  }
};
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 30px;
  width: 80px;
  margin: 0;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.circles {
  position: absolute;
  left: -2px;
  top: 0;
  height: 30px;
  width: 90px;
}

.circles span {
  position: absolute;
  top: 12px;
  height: 6px;
  width: 6px;
  border-radius: 100px;
  background-color: #ccc;
}

.circles span.circle-1 {
  right: 40px;
}

.circles span.circle-2 {
  right: 20px;
}

.circles span.circle-3 {
  right: 0;
}

.circles {
  -webkit-animation: animcircles 0.5s infinite linear;
  animation: animcircles 0.5s infinite linear;
}

@-webkit-keyframes animcircles {
  0% {
    -webkit-transform: translate(0px, 0);
    transform: translate(0px, 0);
  }
  100% {
    -webkit-transform: translate(-20px, 0);
    transform: translate(-20px, 0);
  }
}

@keyframes animcircles {
  0% {
    -webkit-transform: translate(0px, 0);
    transform: translate(0px, 0);
  }
  100% {
    -webkit-transform: translate(-20px, 0);
    transform: translate(-20px, 0);
  }
}

.pacman {
  position: absolute;
  left: 0;
  top: 0;
  height: 30px;
  width: 30px;
}

.pacman .eye {
  position: absolute;
  top: 5px;
  left: 15px;
  height: 4px;
  width: 4px;
  border-radius: 7px;
  background-color: #fff;
}

.pacman span {
  position: absolute;
  top: 0;
  left: 0;
  height: 30px;
  width: 30px;
}

.pacman span::before {
  content: '';
  position: absolute;
  left: 0;
  height: 15px;
  width: 30px;
  background-color: #adb5bd;
}

.pacman .top::before {
  top: 0;
  border-radius: 60px 60px 0 0;
}

.pacman .bottom::before {
  bottom: 0;
  border-radius: 0 0 60px 60px;
}

.pacman .left::before {
  bottom: 0;
  height: 30px;
  width: 15px;
  border-radius: 60px 0 0 60px;
}

.pacman .top {
  -webkit-animation: animtop 0.5s infinite;
  animation: animtop 0.5s infinite;
}

@-webkit-keyframes animtop {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
}

@keyframes animtop {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
}

.pacman .bottom {
  -webkit-animation: animbottom 0.5s infinite;
  animation: animbottom 0.5s infinite;
}

@-webkit-keyframes animbottom {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}

@keyframes animbottom {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}
</style>
